import React from 'react';
import Dialog from 'components/shared/dialog/dialog';
import { Button } from 'components/shared/uniform';
import './login-to-follow-dialog.scss';

class LoginToFollowDialog extends React.Component {
  static propTypes = {
    onClose: React.PropTypes.func.isRequired,
    feedUserTypeId: React.PropTypes.number.isRequired,
    feedUserRelatedId: React.PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.getLoginUrl = this.getLoginUrl.bind(this);
    this.getSignupUrl = this.getSignupUrl.bind(this);
  }

  constructAutoFollowUrl(baseUrl) {
    // CO: Ideally we'd use the URL and URLSearchParams APIs here, but then we'd be double encoding the query params for this URL
    return baseUrl + '?followUserId=' + this.props.feedUserRelatedId + '&followUserType=' + this.props.feedUserTypeId;
  }

  getLoginDirectUrl() {
    const currentUrl = window.location.href;
    const returnUrl = this.constructAutoFollowUrl(currentUrl);
    const loginUrl = new URL('/login', window.location.origin);
    loginUrl.searchParams.set('forward', returnUrl);
    return loginUrl;
  }

  getLoginUrl() {
    const loginUrl = this.getLoginDirectUrl();
    return loginUrl.toString();
  }

  getSignupUrl() {
    const signupUrl = this.getLoginDirectUrl();
    signupUrl.searchParams.set('screen_hint', 'signup');
    return signupUrl.toString();
  }

  render() {
    const buttons = [
      <Button
        key="signup-button"
        type="secondary"
        text="Create Account"
        qaId="create-account-button"
        onClick={() => (window.location.href = this.getSignupUrl())}
      />,
      <Button
        key="login-button"
        type="primary"
        text="Log In"
        qaId="log-in-button"
        onClick={() => (window.location.href = this.getLoginUrl())}
      />,
    ];

    return (
      <Dialog
        title="Log In to Follow"
        buttons={buttons}
        onClose={this.props.onClose}
        className="login-to-follow-dialog">
        <div className="login-to-follow-content" data-qa-id="log-in-to-follow-modal-content">
          <p>Log in or create an account to follow and keep up with everything you care about.</p>
        </div>
      </Dialog>
    );
  }
}

export default LoginToFollowDialog;
